(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gc-capsulas"] && !Shopify.designMode) return;
  try {
    
(function () {
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) {
        var els = Array.prototype.slice.call(document.querySelectorAll('#gc-caps .gc-reveal'));
        var idx = els.indexOf(e.target);
        setTimeout(function () { e.target.classList.add('is-in'); }, Math.min(Math.max(idx, 0) * 70, 420));
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('#gc-caps .gc-reveal').forEach(function (el) { io.observe(el); });

  // Tilt 3D por card (desktop con mouse)
  if (window.matchMedia('(hover: hover)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('#gc-caps .gc-caps__card').forEach(function (card) {
      var raf = null;
      card.addEventListener('mousemove', function (ev) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          var r = card.getBoundingClientRect();
          var x = (ev.clientX - r.left) / r.width - 0.5;
          var y = (ev.clientY - r.top) / r.height - 0.5;
          card.style.transform = 'translateY(-8px) scale(1.015) rotateY(' + (x * 7) + 'deg) rotateX(' + (-y * 6) + 'deg)';
          raf = null;
        });
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-cart-boost"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('gc-cb');
  if (!root) return;
  var threshold = parseInt(root.dataset.threshold, 10);
  function refresh() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var total = cart.total_price;
      var pct = Math.min(100, Math.round(total * 100 / threshold));
      document.getElementById('gc-cb-fill').style.width = pct + '%';
      var bar = root.querySelector('.gc-cb__bar');
      bar.setAttribute('aria-valuenow', pct);
      var msg = document.getElementById('gc-cb-msg');
      if (total >= threshold) {
        msg.innerHTML = '¡Tenés <strong>envío GRATIS</strong> a todo el país!';
      } else {
        var falta = ((threshold - total) / 100).toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        msg.innerHTML = 'Te faltan <strong>$' + falta + '</strong> para el <strong>envío GRATIS</strong>';
      }
    });
  }
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:change', refresh);
  var mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(refresh, 400); });
  var cartEl = document.querySelector('cart-items, .cart-items, [data-cart-items], main');
  if (cartEl) mo.observe(cartEl, { childList: true, subtree: true });

  // Quick-add cross-sell
  document.querySelectorAll('.gc-cb__up').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.disabled = true;
      var label = btn.querySelector('b'); if (label) label.textContent = '…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(btn.dataset.variant, 10), quantity: 1 }) })
        .then(function (r) { if (!r.ok) throw 0; window.location.reload(); })
        .catch(function () { btn.disabled = false; if (label) label.textContent = '+ Agregar'; });
    });
  });

  // Confetti al cruzar el envío gratis (una vez por sesión)
  var celebrated = sessionStorage.getItem('gc-free-ship-party');
  var origRefresh = refresh;
  refresh = function () { origRefresh(); checkParty(); };
  function checkParty() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.total_price >= threshold && !celebrated) {
        celebrated = '1';
        sessionStorage.setItem('gc-free-ship-party', '1');
        var c = document.getElementById('gc-cb-confetti');
        if (!c || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        c.hidden = false;
        c.querySelectorAll('i').forEach(function (p, i) {
          p.style.left = (4 + i * 7) + '%';
          p.style.animationDelay = (i * 60) + 'ms';
        });
        setTimeout(function () { c.hidden = true; }, 2600);
      }
    });
  }
  checkParty();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-comparativa"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ins = document.querySelectorAll('[id^="gc-cmp-in-"]');
  ins.forEach(function (el) {
    new IntersectionObserver(function (es, ob) {
      if (es[0].isIntersecting) { el.classList.add('is-in'); ob.disconnect(); }
    }, { threshold: 0.2 }).observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-cotizador"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('gc-cot');
  if (!root) return;
  var variants = JSON.parse(root.dataset.variants);
  var sel = document.getElementById('gc-cot-variant');
  var qtyInput = document.getElementById('gc-cot-qty');
  var unitEl = document.getElementById('gc-cot-unit');
  var discRow = document.getElementById('gc-cot-disc-row');
  var discEl = document.getElementById('gc-cot-disc');
  var totalEl = document.getElementById('gc-cot-total');
  var addBtn = document.getElementById('gc-cot-add');
  var waLink = document.getElementById('gc-cot-wa');
  var waLabel = document.getElementById('gc-cot-wa-label');

  variants.forEach(function (v) {
    var o = document.createElement('option');
    o.value = v.id; o.textContent = v.title;
    sel.appendChild(o);
  });
  // arrancar con la variante que marca el customizer (Grande por defecto) — si no, la 1ª option es CHICO
  // y el pedido por defecto saldría con variante Chica + property "Tamaño: Grande"
  (function () {
    var want = (window.GC_CUSTOM && window.GC_CUSTOM.size === 'chico') ? /chic/i : /grand/i;
    for (var i = 0; i < sel.options.length; i++) {
      if (want.test(sel.options[i].text)) { sel.selectedIndex = i; break; }
    }
  })();

  function fmt(pesos) {
    return '$' + Math.round(pesos).toLocaleString('es-AR');
  }
  // Precio unitario EXACTO por escalón (10/20/30/50/100) según la medida,
  // interpolando lineal entre escalones intermedios. Tabla real de Patricio.
  function sizeOf(v) { return /chic/i.test(v.title) ? 'chico' : 'grande'; }
  function unitFor(size, q) {
    var t = (window.GC_COT_PRICING || {})[size] || [];
    if (!t.length) return 0;
    if (q <= t[0][0]) return t[0][1];
    var last = t[t.length - 1];
    if (q >= last[0]) return last[1];
    for (var i = 0; i < t.length - 1; i++) {
      var a = t[i], b = t[i + 1];
      if (q >= a[0] && q <= b[0]) {
        return a[1] + (q - a[0]) / (b[0] - a[0]) * (b[1] - a[1]);
      }
    }
    return t[0][1];
  }

  function update() {
    // clamp solo para el cálculo — NO reescribir el input en cada tecla (imposibilita tipear "35")
    var q = Math.max(10, parseInt(qtyInput.value, 10) || 10);
    var v = variants.find(function (x) { return String(x.id) === sel.value; }) || variants[0];
    var size = sizeOf(v);
    var over = q > 100;
    root.classList.toggle('is-wa-only', over);

    // resaltar cada escalón de volumen ya alcanzado por la cantidad
    document.querySelectorAll('.gc-cot__tiers span').forEach(function (s) {
      var t = parseInt(s.dataset.tier, 10);
      s.classList.toggle('is-active', !over && q >= t);
    });

    var msg;
    if (over) {
      addBtn.hidden = true;
      waLabel.textContent = 'Cotizar +100 u. por WhatsApp';
      msg = 'Hola! Quiero cotizar un pedido mayorista de Gripcoolers personalizadas.\nModelo: ' + v.title + '\nCantidad: ' + q + ' unidades';
    } else {
      addBtn.hidden = false;
      var unit = unitFor(size, q);
      var base = unitFor(size, 10);
      var saved = (base - unit) * q;
      unitEl.textContent = (saved > 0.5) ? (fmt(base) + ' → ' + fmt(unit)) : fmt(unit);
      discRow.hidden = !(saved > 0.5);
      if (saved > 0.5) discEl.textContent = '−' + fmt(saved);
      totalEl.textContent = fmt(unit * q);
      totalEl.classList.remove('is-bump'); void totalEl.offsetWidth; totalEl.classList.add('is-bump');
      waLabel.textContent = 'Enviar cotización por WhatsApp';
      msg = 'Hola! Coticé en la web Gripcoolers personalizadas:\nModelo: ' + v.title + '\nCantidad: ' + q + ' u.\nPrecio unitario: ' + fmt(unit) + '\nTotal estimado: ' + fmt(unit * q);
    }
    waLink.href = 'https://wa.me/5491131172598?text=' + encodeURIComponent(msg);
  }

  // sync bidireccional: cambiar el Modelo acá también actualiza el tamaño del customizer (mockup + property)
  sel.addEventListener('change', function () {
    var vt = (sel.options[sel.selectedIndex] || {}).text || '';
    var sz = /chic/i.test(vt) ? 'chico' : 'grande';
    if (window.GC_CUSTOM && window.GC_CUSTOM.size !== sz) {
      if (window.gcApplySize) window.gcApplySize(sz); else window.GC_CUSTOM.size = sz;
      if (window.gcPersistDesign) window.gcPersistDesign(window.GC_CUSTOM._d);
    }
    update();
  });
  qtyInput.addEventListener('input', update);
  qtyInput.addEventListener('change', function () { qtyInput.value = Math.max(10, parseInt(qtyInput.value, 10) || 10); update(); });
  document.getElementById('gc-cot-minus').addEventListener('click', function () { qtyInput.value = Math.max(10, (parseInt(qtyInput.value, 10) || 10) - 1); update(); });
  document.getElementById('gc-cot-plus').addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 10) + 1; update(); });

  addBtn.addEventListener('click', function () {
    var q = parseInt(qtyInput.value, 10) || 10;
    addBtn.disabled = true; addBtn.textContent = 'Agregando…';
    var fd = new FormData();
    fd.append('id', sel.value);
    fd.append('quantity', q);
    var cz = window.GC_CUSTOM || {};
    // la property Tamaño se deriva SIEMPRE de la variante elegida: variante y property no pueden contradecirse
    var vtxt = (sel.options[sel.selectedIndex] || {}).text || '';
    fd.append('properties[Tamaño]', /chic/i.test(vtxt) ? 'Chica' : 'Grande');
    if (cz.bodyColor) fd.append('properties[Color del cooler]', cz.bodyColor);
    if (cz.gripColor) fd.append('properties[Color del grip]', cz.gripColor);
    if (cz.text) fd.append('properties[Texto estampado]', cz.text);
    if (cz.text && cz.textColor) fd.append('properties[Color del texto]', cz.textColor);
    if (cz.text && cz.font) fd.append('properties[Tipografía]', cz.font);
    if (cz.notes) fd.append('properties[Notas del diseño]', cz.notes);
    if (cz.file) fd.append('properties[Archivo de diseño]', cz.file, cz.file.name);
    fetch('/cart/add', { method: 'POST', body: fd }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      window.location.href = '/cart';
    }).catch(function () {
      addBtn.disabled = false; addBtn.textContent = 'Agregar al carrito';
      alert('No pudimos agregar al carrito. Probá de nuevo o escribinos por WhatsApp.');
    });
  });

  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-cta-mayorista"] && !Shopify.designMode) return;
  try {
    
(function () {
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.2 });
  document.querySelectorAll('#gc-b2b .gc-reveal').forEach(function (el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-customizer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('gc-cz');
  if (!root) return;
  var steps = document.getElementById('gc-cz-steps');
  if (steps) {
    new IntersectionObserver(function (es) { if (es[0].isIntersecting) steps.classList.add('is-in'); }, { threshold: 0.6 }).observe(steps);
  }
  // Mockups fotorrealistas reales (assets IA). Cada opción = combo cuerpo + manija.
  var COLORS_7L = [
    { hex: '#F2F2F2', name: 'Blanco', mock: 'blanco', grip: 'Roja' },
    { hex: '#1A1A1A', name: 'Negro', mock: 'negro', grip: 'Blanca' },
    { hex: '#F26B1F', name: 'Naranja', mock: 'naranja', grip: 'Blanca' },
    { hex: '#1B2A55', name: 'Azul Marino', mock: 'navy', grip: 'Blanca' },
    { hex: '#6B4A2E', name: 'Marrón', mock: 'marron', grip: 'Blanca' },
    { hex: '#F49AC2', name: 'Rosa', mock: 'rosa', grip: 'Blanca' },
    { hex: '#9AA0A6', name: 'Gris', mock: 'gris', grip: 'Blanca' },
    { hex: '#1F4FD8', name: 'Azul', mock: 'azul', grip: 'Blanca' },
    { hex: '#D9C9A8', name: 'Beige', mock: 'beige', grip: 'Roja' },
    { hex: '#D7262E', name: 'Rojo', mock: 'rojo', grip: 'Blanca' },
    { hex: '#2F9E44', name: 'Verde', mock: 'verde', grip: 'Blanca' },
    { hex: '#F5C518', name: 'Amarillo', mock: 'amarillo', grip: 'Blanca' },
    { hex: '#E0218A', name: 'Fucsia', mock: 'fucsia', grip: 'Blanca' }
  ];
  // Paleta REAL del cliente — MANIJA. {hex, nombre}
  var GRIP_COLORS = [
    { hex: '#D7262E', name: 'Roja' },
    { hex: '#1A1A1A', name: 'Negra' },
    { hex: '#FAFAFA', name: 'Blanca' },
    { hex: '#F49AC2', name: 'Rosa' },
    { hex: '#E7D8B8', name: 'Beige' },
    { hex: '#F68012', name: 'Naranja' },
    { hex: '#15C0FF', name: 'Azul eléctrico' },
    { hex: '#D4AF37', name: 'Dorada' },
    { hex: '#E0218A', name: 'Fucsia' }
  ];
  var TEXT_COLORS = [
    { hex: '#0A1A2F', name: 'Azul noche' },
    { hex: '#FFFFFF', name: 'Blanco' },
    { hex: '#D7262E', name: 'Rojo' },
    { hex: '#E8C964', name: 'Dorado' },
    { hex: '#15C0FF', name: 'Azul eléctrico' },
    { hex: '#2FAE54', name: 'Verde' },
    { hex: '#E0218A', name: 'Fucsia' },
    { hex: '#1A1A1A', name: 'Negro' }
  ];
  window.GC_CUSTOM = { file: null, size: 'grande', bodyColor: 'Blanco', bodyHex: '#F2F2F2', mock: 'blanco', gripColor: 'Roja', gripHex: '#D7262E', textColor: '#0A1A2F', text: '', font: 'display', notes: '' };

  var tintBody = document.getElementById('gc-cz-tint-body');
  var tintHandle = document.getElementById('gc-cz-tint-handle');
  var photo = document.getElementById('gc-cz-photo');
  var frapera = photo ? photo.parentElement : null;
  var logo = document.getElementById('gc-cz-logo');
  var textEl = document.getElementById('gc-cz-text');
  var area = document.getElementById('gc-cz-area');
  var stage = document.getElementById('gc-cz-stage');
  var controls = document.getElementById('gc-cz-controls');
  var scale = document.getElementById('gc-cz-scale');
  var sumBody = document.getElementById('gc-cz-sum-body');
  var sumGrip = document.getElementById('gc-cz-sum-grip');
  var active = null;

  function persistDesign(dataURL) {
    try {
      var c = window.GC_CUSTOM;
      localStorage.setItem('gc-design', JSON.stringify({
        d: dataURL || null, n: c.file ? c.file.name : null,
        body: c.bodyHex, mock: c.mock, grip: c.gripHex, tcol: c.textColor, txt: c.text, font: c.font,
        notes: c.notes, size: c.size
      }));
    } catch (e) {}
    if (window.gcUpdateWaLink) window.gcUpdateWaLink();
  }
  window.gcPersistDesign = persistDesign;
  // WhatsApp: wa.me NO adjunta archivos, así que mandamos el RESUMEN del diseño y pedimos la imagen en el chat.
  var waAlt = document.getElementById('gc-cz-wa-alt');
  function updateWaLink() {
    if (!waAlt) return;
    var c = window.GC_CUSTOM;
    var L = ['Hola! Diseñé mi Gripcooler en la web y quiero pedirla:'];
    L.push('• Tamaño: ' + (c.size === 'chico' ? 'Chica' : 'Grande'));
    L.push('• Color del cooler: ' + c.bodyColor);
    L.push('• Color de la manija: ' + c.gripColor);
    if (c.text) L.push('• Texto estampado: "' + c.text + '"');
    if (c.notes) L.push('• Notas: ' + c.notes);
    L.push('');
    L.push(c.file ? 'Te adjunto la imagen de mi logo/diseño acá en el chat 👇' : 'Les paso el logo/diseño por acá 👇');
    waAlt.href = 'https://wa.me/5491131172598?text=' + encodeURIComponent(L.join('\n'));
  }
  window.gcUpdateWaLink = updateWaLink;
  function markDesigned() { if (stage) stage.setAttribute('data-empty', 'false'); }
  function syncSummary() {
    if (sumBody) sumBody.style.background = window.GC_CUSTOM.bodyHex;
    if (sumGrip) sumGrip.style.background = window.GC_CUSTOM.gripHex;
  }
  function setActive(el) {
    active = el;
    [logo, textEl].forEach(function (x) { if (x) x.classList.toggle('is-active', x === el); });
    if (controls && el) controls.hidden = false;
    if (scale && el) {
      var cur = el === logo ? parseFloat(el.style.width) || 60 : (parseFloat(el.dataset.size) || 60);
      scale.value = cur;
    }
  }

  // El arte NUNCA sobrepasa el área de impresión (16×12): lo que se ve dentro de la guía = lo que se estampa.
  function clampInside(el) {
    if (!area || !el || el.hidden) return;
    if (el === textEl && textEl.dataset.centered !== '0') return; // aún centrado vía translate(-50%,-50%)
    var maxL = Math.max(area.clientWidth - el.offsetWidth, 0);
    var maxT = Math.max(area.clientHeight - el.offsetHeight, 0);
    var L = el.offsetLeft, T = el.offsetTop;
    var nl = Math.min(Math.max(L, 0), maxL), nt = Math.min(Math.max(T, 0), maxT);
    if (nl !== L) el.style.left = nl + 'px';
    if (nt !== T) el.style.top = nt + 'px';
  }
  function fitLogo() {
    if (!area || logo.hidden || !logo.offsetWidth) return;
    if (logo.offsetHeight > area.clientHeight) {
      var w = logo.offsetWidth * area.clientHeight / logo.offsetHeight;
      logo.style.width = Math.max((w / area.clientWidth) * 100, 10) + '%';
    }
    clampInside(logo);
  }
  function fitText() {
    if (!area || textEl.hidden) return;
    var cur = parseFloat(textEl.style.fontSize) || 13; // en cqw
    var guard = 0;
    while (textEl.offsetWidth > area.clientWidth && cur > 3 && guard < 60) {
      cur -= 0.5; textEl.style.fontSize = cur + 'cqw'; guard++;
    }
    clampInside(textEl);
  }
  if (logo) logo.addEventListener('load', fitLogo);

  function buildSwatches(containerId, colors, onPick, initial) {
    var box = document.getElementById(containerId);
    colors.forEach(function (c) {
      var hex = c.hex, name = c.name;
      var b = document.createElement('button');
      b.type = 'button'; b.style.background = hex;
      b.setAttribute('role', 'radio');
      b.setAttribute('data-hex', hex);
      if (c.mock) b.setAttribute('data-mock', c.mock);
      b.setAttribute('title', name);
      b.setAttribute('aria-label', name + ' (' + hex + ')');
      b.setAttribute('aria-checked', hex === initial ? 'true' : 'false');
      b.addEventListener('click', function () {
        box.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-checked', 'true'); onPick(hex, name, c);
      });
      box.appendChild(b);
    });
  }
  // #27 Patricio: el logo Gripcooler estampado se pinta SIEMPRE del color de la manija
  var brandmark = document.getElementById('gc-cz-brandmark');
  function setGripUI(hex, name) {
    window.GC_CUSTOM.gripColor = name; window.GC_CUSTOM.gripHex = hex;
    if (brandmark) brandmark.style.background = hex;
    var gbox = document.getElementById('gc-cz-grip-colors');
    if (gbox) gbox.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-checked', (x.getAttribute('data-hex') || '').toUpperCase() === hex.toUpperCase() ? 'true' : 'false'); });
    syncSummary();
  }
  buildSwatches('gc-cz-body-colors', COLORS_7L, function (hex, name, c) {
    if (photo && frapera && c && c.mock) { var u = frapera.getAttribute('data-mock-' + c.mock); if (u) photo.src = u; }
    window.GC_CUSTOM.bodyColor = name; window.GC_CUSTOM.bodyHex = hex;
    if (c && c.mock) window.GC_CUSTOM.mock = c.mock;
    if (c && c.grip) { var GH={Roja:'#D7262E',Rosa:'#F49AC2',Blanca:'#FAFAFA',Naranja:'#F68012'}; setGripUI(GH[c.grip] || '#D7262E', c.grip); }
    syncSummary(); persistDesign(window.GC_CUSTOM._d);
  }, '#F2F2F2');
  buildSwatches('gc-cz-grip-colors', GRIP_COLORS, function (hex, name) {
    setGripUI(hex, name); persistDesign(window.GC_CUSTOM._d);
  }, '#D7262E');
  buildSwatches('gc-cz-text-colors', TEXT_COLORS, function (hex) {
    textEl.style.color = hex; window.GC_CUSTOM.textColor = hex; persistDesign(window.GC_CUSTOM._d);
  }, '#0A1A2F');

  // SELECTOR DE TAMAÑO (Chica / Grande) — achica el mockup y registra la talla en el pedido
  var sizeBox = document.getElementById('gc-cz-sizes');
  var printGuide = area ? area.querySelector('.gc-cz__print-guide') : null;
  var SIZE_AREAS = { grande: '16 × 12 cm', chico: '13 × 10 cm' };
  function syncCotizadorSize(sz) {
    var csel = document.getElementById('gc-cot-variant');
    if (!csel || !csel.options.length) return;
    var want = sz === 'chico' ? 'chic' : 'grand';
    for (var i = 0; i < csel.options.length; i++) {
      if ((csel.options[i].text || '').toLowerCase().indexOf(want) >= 0) {
        if (csel.selectedIndex !== i) { csel.selectedIndex = i; csel.dispatchEvent(new Event('change')); }
        break;
      }
    }
  }
  function applySize(sz) {
    window.GC_CUSTOM.size = sz;
    if (stage) stage.setAttribute('data-size', sz);
    if (printGuide) printGuide.innerHTML = 'Área de impresión<br><b>' + (SIZE_AREAS[sz] || SIZE_AREAS.grande) + '</b>';
    if (sizeBox) sizeBox.querySelectorAll('.gc-cz__size').forEach(function (b) {
      b.setAttribute('aria-checked', b.dataset.size === sz ? 'true' : 'false');
    });
    syncCotizadorSize(sz);
  }
  window.gcApplySize = applySize;
  applySize('grande');
  if (sizeBox) sizeBox.querySelectorAll('.gc-cz__size').forEach(function (btn) {
    btn.addEventListener('click', function () { applySize(btn.dataset.size); persistDesign(window.GC_CUSTOM._d); });
  });

  // TEXTO personalizado
  var textInput = document.getElementById('gc-cz-text-input');
  var textFont = document.getElementById('gc-cz-text-font');
  function showText() {
    var v = textInput.value.trim();
    window.GC_CUSTOM.text = v;
    if (v) {
      textEl.textContent = v; textEl.hidden = false;
      if (!textEl.dataset.placed) { textEl.style.left = '50%'; textEl.style.top = '62%'; textEl.style.transform = 'translate(-50%,-50%) perspective(260px) rotateY(6deg)'; textEl.dataset.placed = '1'; textEl.dataset.size = '60'; }
      fitText();
      markDesigned(); setActive(textEl);
      document.getElementById('gc-cz-attach-note').hidden = false;
    } else { textEl.hidden = true; if (active === textEl) setActive(logo.hidden ? null : logo); }
    persistDesign(window.GC_CUSTOM._d);
  }
  textInput.addEventListener('input', showText);
  textFont.addEventListener('change', function () { window.GC_CUSTOM.font = this.value; textEl.dataset.font = this.value; persistDesign(window.GC_CUSTOM._d); });

  // Quita el fondo SÓLIDO del logo al subirlo (detección por esquinas). Respeta PNGs ya transparentes y fotos complejas.
  function gcRemoveBg(srcUrl, cb) {
    var im = new Image();
    im.onload = function () {
      try {
        var w = im.naturalWidth, h = im.naturalHeight;
        if (!w || !h) { cb(srcUrl); return; }
        var cap = 900, sc = Math.min(1, cap / Math.max(w, h));
        var cw = Math.max(1, Math.round(w * sc)), ch = Math.max(1, Math.round(h * sc));
        var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
        var cx = cv.getContext('2d'); cx.drawImage(im, 0, 0, cw, ch);
        var id; try { id = cx.getImageData(0, 0, cw, ch); } catch (e) { cb(srcUrl); return; }
        var d = id.data, N = cw * ch, i, transp = 0;
        for (i = 3; i < d.length; i += 4) { if (d[i] < 240) transp++; }
        if (transp > N * 0.06) { cb(srcUrl); return; } // ya tiene transparencia → no tocar
        function corner(x, y) { var p = (y * cw + x) * 4; return [d[p], d[p + 1], d[p + 2]]; }
        var pts = [corner(0, 0), corner(cw - 1, 0), corner(0, ch - 1), corner(cw - 1, ch - 1), corner((cw >> 1), 0), corner(0, (ch >> 1))];
        var bg = [0, 0, 0], k;
        for (k = 0; k < pts.length; k++) { bg[0] += pts[k][0]; bg[1] += pts[k][1]; bg[2] += pts[k][2]; }
        bg = [bg[0] / pts.length, bg[1] / pts.length, bg[2] / pts.length];
        var vr = 0;
        for (k = 0; k < pts.length; k++) { vr += Math.abs(pts[k][0] - bg[0]) + Math.abs(pts[k][1] - bg[1]) + Math.abs(pts[k][2] - bg[2]); }
        vr /= pts.length;
        if (vr > 34) { cb(srcUrl); return; } // esquinas dispares → fondo no uniforme, no tocar
        var tol = 52, soft = 26;
        for (i = 0; i < d.length; i += 4) {
          var dr = d[i] - bg[0], dg = d[i + 1] - bg[1], db = d[i + 2] - bg[2];
          var dist = Math.sqrt(dr * dr + dg * dg + db * db);
          if (dist < tol) { d[i + 3] = 0; }
          else if (dist < tol + soft) { d[i + 3] = Math.round(d[i + 3] * (dist - tol) / soft); }
        }
        cx.putImageData(id, 0, 0);
        cb(cv.toDataURL('image/png'));
      } catch (e) { cb(srcUrl); }
    };
    im.onerror = function () { cb(srcUrl); };
    im.src = srcUrl;
  }

  // LOGO upload
  var fileInput = document.getElementById('gc-cz-file');
  fileInput.addEventListener('change', function () {
    var f = fileInput.files[0]; if (!f) return;
    window.GC_CUSTOM.file = f;
    if (/^image\//.test(f.type) && f.size < 3800000) {
      var fr = new FileReader(); fr.onload = function () { window.GC_CUSTOM._d = fr.result; persistDesign(fr.result); }; fr.readAsDataURL(f);
    } else { persistDesign(null); }
    document.getElementById('gc-cz-file-label').textContent = '✓ ' + f.name;
    fileInput.closest('.gc-cz__upload').classList.add('has-file');
    document.getElementById('gc-cz-attach-note').hidden = false;
    if (/^image\/(png|jpe?g|svg)/.test(f.type)) {
      var _url = URL.createObjectURL(f);
      if (/^image\/(png|jpe?g)/.test(f.type)) { gcRemoveBg(_url, function (out) { logo.src = out; }); }
      else { logo.src = _url; }
      logo.hidden = false;
      logo.style.width = '52%'; logo.style.left = '24%'; logo.style.top = '49%';
      markDesigned(); setActive(logo);
    }
  });

  // Slider escala el ELEMENTO ACTIVO (logo: width%, texto: font-size)
  scale.addEventListener('input', function () {
    if (!active) return;
    if (active === logo) { logo.style.width = this.value + '%'; fitLogo(); }
    else { active.dataset.size = this.value; active.style.fontSize = (4 + this.value * 0.15) + 'cqw'; fitText(); }
  });

  // DRAG genérico (logo y texto)
  function makeDraggable(el) {
    var dragging = false, sx, sy, sl, st;
    el.addEventListener('pointerdown', function (e) {
      setActive(el); dragging = true; sx = e.clientX; sy = e.clientY;
      if (el === textEl && textEl.dataset.centered !== '0') {
        // pasar de translate(-50%,-50%) a coordenadas absolutas sin salto visual
        textEl.style.left = (textEl.offsetLeft - textEl.offsetWidth / 2) + 'px';
        textEl.style.top = (textEl.offsetTop - textEl.offsetHeight / 2) + 'px';
        textEl.style.transform = 'perspective(260px) rotateY(6deg)';
        textEl.dataset.centered = '0';
      }
      sl = el.offsetLeft; st = el.offsetTop;
      if (stage) stage.classList.add('is-dragging');
      el.setPointerCapture(e.pointerId); e.preventDefault();
    });
    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var maxL = Math.max(area.clientWidth - el.offsetWidth, 0);
      var maxT = Math.max(area.clientHeight - el.offsetHeight, 0);
      el.style.left = Math.min(Math.max(sl + e.clientX - sx, 0), maxL) + 'px';
      el.style.top = Math.min(Math.max(st + e.clientY - sy, 0), maxT) + 'px';
    });
    function end() { dragging = false; if (stage) stage.classList.remove('is-dragging'); }
    el.addEventListener('pointerup', end); el.addEventListener('pointercancel', end);
  }
  makeDraggable(logo); makeDraggable(textEl);

  document.getElementById('gc-cz-notes').addEventListener('input', function () { window.GC_CUSTOM.notes = this.value; persistDesign(window.GC_CUSTOM._d); });

  // #29 Patricio — "enviar tu diseño no manda nada": el CTA del customizer sólo hacía scroll con un ancla (#gc-cot)
  // y el envío real (add-to-cart con el archivo como line item property FILE nativo) vive en gc-cotizador (#gc-cot-add).
  // Muchos usuarios "armaban el diseño", tocaban el CTA y creían haberlo enviado, pero el segundo paso quedaba invisible.
  // Acá: al tocar el CTA persistimos el diseño, llevamos al botón de envío real y lo resaltamos. Si NO hay cotizador en
  // la página (p.ej. landing standalone sin producto personalizable), caemos a WhatsApp, que es la única vía de envío.
  [].slice.call(root.querySelectorAll('.gc-cz__next')).forEach(function (cta) {
    cta.addEventListener('click', function (e) {
      persistDesign(window.GC_CUSTOM._d);
      var addBtn = document.getElementById('gc-cot-add');
      if (!addBtn) {
        updateWaLink();
        if (waAlt && waAlt.href) { e.preventDefault(); window.open(waAlt.href, '_blank', 'noopener'); }
        return;
      }
      // dejamos que el ancla haga su scroll a #gc-cot y, ya ahí, resaltamos el botón que efectivamente envía el diseño
      setTimeout(function () {
        try { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (er) {}
        try {
          addBtn.animate([
            { boxShadow: '0 0 0 0 rgba(232,201,100,.9)' },
            { boxShadow: '0 0 0 16px rgba(232,201,100,0)' }
          ], { duration: 900, iterations: 3 });
        } catch (er) {}
      }, 420);
    });
  });

  // TILT 3D
  var craft = document.getElementById('gc-cz-craft');
  var coarse = window.matchMedia('(pointer:coarse)').matches;
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  if (craft && stage && !coarse && !reduce) {
    var tRx = 0, tRy = 0, cRx = 0, cRy = 0, hovering = false, t0 = null, dragging2 = false;
    stage.addEventListener('pointerdown', function () { dragging2 = stage.classList.contains('is-dragging'); });
    stage.addEventListener('pointermove', function (e) {
      if (stage.classList.contains('is-dragging')) return;
      var r = stage.getBoundingClientRect();
      tRy = ((e.clientX - r.left) / r.width - 0.5) * 15;
      tRx = -((e.clientY - r.top) / r.height - 0.5) * 8; hovering = true;
    });
    stage.addEventListener('pointerleave', function () { hovering = false; });
    (function loop(ts) {
      if (t0 === null) t0 = ts;
      var el = (ts - t0) / 1000;
      if (!hovering && !stage.classList.contains('is-dragging')) { tRy = Math.sin(el * 0.7) * 5.5; tRx = Math.cos(el * 0.5) * 2; }
      if (stage.classList.contains('is-dragging')) { tRx = 0; tRy = 0; }
      cRx += (tRx - cRx) * 0.09; cRy += (tRy - cRy) * 0.09;
      craft.style.setProperty('--rx', cRx.toFixed(2) + 'deg');
      craft.style.setProperty('--ry', cRy.toFixed(2) + 'deg');
      requestAnimationFrame(loop);
    })(0);
  }

  // #27 Patricio — el logo/marca "Gripcooler" del preview arranca teñido al tono de la manija actual (no sólo tras un click)
  setGripUI(window.GC_CUSTOM.gripHex, window.GC_CUSTOM.gripColor);
  syncSummary();
  updateWaLink();

  // RESTAURAR diseño previo
  try {
    var saved = JSON.parse(localStorage.getItem('gc-design') || 'null');
    if (saved) {
      function clickColor(boxSel, val) { var b = [].slice.call(document.querySelectorAll(boxSel + ' button')).find(function (x) { return (x.getAttribute('data-hex') || '').toUpperCase() === String(val).toUpperCase(); }); if (b) b.click(); }
      // restaurar por mock (único) y no por hex: "Azul Marino" y "Azul + Naranja" comparten #1B2A55
      var bodyBtn = saved.mock && [].slice.call(document.querySelectorAll('#gc-cz-body-colors button')).find(function (x) { return x.getAttribute('data-mock') === saved.mock; });
      if (bodyBtn) bodyBtn.click();
      else if (saved.body) clickColor('#gc-cz-body-colors', saved.body);
      if (saved.grip) clickColor('#gc-cz-grip-colors', saved.grip);
      if (saved.tcol) clickColor('#gc-cz-text-colors', saved.tcol);
      if (saved.font) { textFont.value = saved.font; window.GC_CUSTOM.font = saved.font; textEl.dataset.font = saved.font; }
      if (saved.size) applySize(saved.size);
      if (saved.notes) { var ns = document.getElementById('gc-cz-notes'); if (ns) { ns.value = saved.notes; window.GC_CUSTOM.notes = saved.notes; } }
      if (saved.txt) { textInput.value = saved.txt; showText(); }
      if (saved.d) {
        window.GC_CUSTOM._d = saved.d;
        logo.src = saved.d; logo.hidden = false;
        logo.style.width = '52%'; logo.style.left = '24%'; logo.style.top = '49%';
        document.getElementById('gc-cz-file-label').textContent = '✓ ' + (saved.n || 'tu diseño guardado');
        fileInput.closest('.gc-cz__upload').classList.add('has-file');
        document.getElementById('gc-cz-attach-note').hidden = false;
        markDesigned(); setActive(logo);
        fetch(saved.d).then(function (r) { return r.blob(); }).then(function (b) { window.GC_CUSTOM.file = new File([b], saved.n || 'diseno.png', { type: b.type }); }).catch(function () {});
        var msg = document.createElement('div'); msg.className = 'gc-cz__restored is-on';
        msg.textContent = '✓ Restauramos tu diseño guardado — seguí donde lo dejaste.';
        document.querySelector('.gc-cz__panel').prepend(msg);
      }
      syncSummary();
    }
  } catch (e) {}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-exit-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var dlg = document.getElementById('gc-xo');
  if (!dlg || !dlg.showModal) return;
  var KEY = 'gc-exit-offer-shown';
  if (sessionStorage.getItem(KEY)) return;

  function show() {
    if (sessionStorage.getItem(KEY) || dlg.open) return;
    sessionStorage.setItem(KEY, '1');
    try { dlg.showModal(); } catch (e) {}
  }
  function close() { if (dlg.open) dlg.close(); }

  document.getElementById('gc-xo-close').addEventListener('click', close);
  dlg.addEventListener('click', function (e) {
    var r = dlg.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close();
  });

  document.getElementById('gc-xo-code').addEventListener('click', function () {
    var hint = document.getElementById('gc-xo-copy-hint');
    if (navigator.clipboard) navigator.clipboard.writeText('BIENVENIDA10').then(function () {
      hint.textContent = '✓ copiado';
      setTimeout(function () { hint.textContent = 'tocá para copiar'; }, 2000);
    });
  });

  if (window.matchMedia('(hover: hover)').matches) {
    // Desktop: exit-intent real (mouse sale por arriba), recién a partir de los 12s
    var armed = false;
    setTimeout(function () { armed = true; }, 12000);
    document.documentElement.addEventListener('mouseleave', function (e) {
      if (armed && e.clientY <= 0) show();
    });
  } else {
    // Mobile: a los 45s de navegación
    setTimeout(show, 45000);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-garantias"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grids = document.querySelectorAll('[id^="gc-gz-grid-"]');
  grids.forEach(function (g) {
    new IntersectionObserver(function (es, ob) {
      if (es[0].isIntersecting) { g.classList.add('is-in'); ob.disconnect(); }
    }, { threshold: 0.25 }).observe(g);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-hero-mundial"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hero = document.getElementById('gc-hero');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e, i) {
      if (e.isIntersecting) {
        setTimeout(function () { e.target.classList.add('is-in'); }, reduced ? 0 : Math.min(i * 90, 360));
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.18 });
  document.querySelectorAll('#gc-hero .gc-reveal').forEach(function (el) { io.observe(el); });

  // Starfield 3D: 3 capas de profundidad, drift + twinkle + parallax de mouse
  var cv = document.getElementById('gc-starcanvas');
  if (cv && !reduced) {
    var ctx = cv.getContext('2d');
    var stars = [], W, H, mx = 0, my = 0;
    function sizeCanvas() {
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      W = cv.clientWidth; H = cv.clientHeight;
      cv.width = W * dpr; cv.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    sizeCanvas();
    window.addEventListener('resize', sizeCanvas);
    var COLORS = ['rgba(212,175,55,', 'rgba(156,200,238,', 'rgba(244,248,252,'];
    for (var i = 0; i < 70; i++) {
      var depth = 0.3 + Math.random() * 0.7;
      stars.push({ x: Math.random(), y: Math.random(), d: depth, r: depth * 1.6,
        c: COLORS[i % 3], tw: Math.random() * 6.28, ts: 0.5 + Math.random() * 1.5,
        vx: (Math.random() - 0.5) * 0.00012 });
    }
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      mx = (e.clientX - r.left) / r.width - 0.5;
      my = (e.clientY - r.top) / r.height - 0.5;
    });
    var visible = true;
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(hero);
    (function draw(t) {
      requestAnimationFrame(draw);
      if (!visible) return;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        s.x += s.vx * s.d; if (s.x > 1.02) s.x = -0.02; if (s.x < -0.02) s.x = 1.02;
        var alpha = (0.25 + 0.55 * Math.abs(Math.sin(t * 0.001 * s.ts + s.tw))) * s.d;
        var px = s.x * W + mx * 34 * s.d;
        var py = s.y * H + my * 22 * s.d;
        ctx.beginPath();
        ctx.arc(px, py, s.r, 0, 6.28);
        ctx.fillStyle = s.c + alpha + ')';
        ctx.fill();
      }
    })(0);
  }

  // Parallax scroll-driven: capas a distinta velocidad
  if (!reduced) {
    var glowG = hero.querySelector('.gc-hero__glow--gold');
    var glowS = hero.querySelector('.gc-hero__glow--sky');
    var stripes = hero.querySelector('.gc-hero__stripes');
    var visual = hero.querySelector('.gc-hero__visual');
    var year = document.getElementById('gc-hero-year');
    var rafP = null;
    window.addEventListener('scroll', function () {
      if (rafP) return;
      rafP = requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y < window.innerHeight * 1.3) {
          if (glowG) glowG.style.transform = 'translateY(' + y * 0.18 + 'px)';
          if (glowS) glowS.style.transform = 'translateY(' + y * -0.12 + 'px)';
          if (stripes) stripes.style.transform = 'skewX(-14deg) translateY(' + y * 0.25 + 'px)';
          if (visual) visual.style.transform = 'translateY(' + y * 0.1 + 'px)';
          if (year) year.style.transform = 'translateY(' + y * -0.22 + 'px)';
        }
        rafP = null;
      });
    }, { passive: true });
  }

  if (reduced || !window.matchMedia('(hover: hover)').matches) return;
  var wrap = document.getElementById('gc-hero-tilt');
  var img = wrap && wrap.querySelector('.gc-hero__img');
  if (!img) return;
  var raf = null;
  wrap.addEventListener('mousemove', function (ev) {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      var r = wrap.getBoundingClientRect();
      var x = (ev.clientX - r.left) / r.width - 0.5;
      var y = (ev.clientY - r.top) / r.height - 0.5;
      img.style.transform = 'rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 8) + 'deg) scale(1.02)';
      raf = null;
    });
  });
  wrap.addEventListener('mouseleave', function () {
    img.style.transform = '';
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-inspiracion"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grids = document.querySelectorAll('[id^="gc-ins-grid-"]');
  grids.forEach(function (g) {
    new IntersectionObserver(function (es, ob) {
      if (es[0].isIntersecting) { g.classList.add('is-in'); ob.disconnect(); }
    }, { threshold: 0.2 }).observe(g);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-manifiesto"] && !Shopify.designMode) return;
  try {
    
(function () {
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) {
        var els = Array.prototype.slice.call(document.querySelectorAll('#gc-mani .gc-reveal'));
        var idx = els.indexOf(e.target);
        setTimeout(function () { e.target.classList.add('is-in'); }, Math.min(Math.max(idx, 0) * 120, 600));
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.25 });
  document.querySelectorAll('#gc-mani .gc-reveal').forEach(function (el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-pdp-boost"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('gc-pb');
  if (!root) return;

  // Countdown evergreen: la oferta del día termina 23:59:59 hora AR (UTC-3)
  function tick() {
    var now = new Date();
    var ar = new Date(now.toLocaleString('en-US', { timeZone: 'America/Argentina/Buenos_Aires' }));
    var end = new Date(ar); end.setHours(23, 59, 59, 999);
    var diff = end - ar;
    var h = Math.floor(diff / 3600000), m = Math.floor(diff % 3600000 / 60000), s = Math.floor(diff % 60000 / 1000);
    var eh = document.getElementById('gc-pb-h'); if (!eh) return;
    eh.textContent = String(h).padStart(2, '0');
    document.getElementById('gc-pb-m').textContent = String(m).padStart(2, '0');
    document.getElementById('gc-pb-s').textContent = String(s).padStart(2, '0');
  }
  tick(); setInterval(tick, 1000);

  // Viewers determinístico: estable por producto + hora (sin números inventados al azar por reload)
  var pid = parseInt(root.dataset.product, 10) || 1;
  var hour = Math.floor(Date.now() / 3600000);
  var seed = (pid + hour * 2654435761) % 2147483647;
  var viewers = 9 + (seed % 19); // 9–27, fijo durante la hora
  var vEl = document.getElementById('gc-pb-viewers');
  if (vEl) vEl.textContent = viewers;

  // Comparador Chico vs Grande: montar tras el strip de compra + lógica
  var sizer = document.getElementById('gc-size');
  if (sizer) {
    var DATA = {
      '7': { alto: '30 cm', ancho: '38 cm', ideal: 'uso personal, regalo, la previa de dos.', caben: '6 latas + hielo, o 2 botellas + hielo.' },
      '12': { alto: '40 cm', ancho: '40 cm', ideal: 'grupos, asados, eventos y la noche larga.', caben: '12 latas + hielo, o 4 botellas + hielo.' }
    };
    sizer.querySelectorAll('[data-sz]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sz = btn.dataset.sz;
        sizer.querySelectorAll('[data-sz]').forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
        sizer.classList.toggle('is-12', sz === '12');
        document.getElementById('gc-size-alto').textContent = DATA[sz].alto;
        document.getElementById('gc-size-ancho').textContent = DATA[sz].ancho;
        document.getElementById('gc-size-ideal').innerHTML = '<strong>Ideal para:</strong> ' + DATA[sz].ideal;
        document.getElementById('gc-size-caben').innerHTML = '<strong>Entran:</strong> ' + DATA[sz].caben;
      });
    });
  }

  // Burst dorado al agregar al carrito
  window.gcBurst = function (x, y) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var b = document.createElement('div');
    b.className = 'gc-burst';
    b.style.left = x + 'px'; b.style.top = y + 'px';
    for (var i = 0; i < 10; i++) {
      var p = document.createElement('i');
      var ang = i / 10 * 6.28, dist = 40 + Math.random() * 50;
      p.style.setProperty('--bx', Math.cos(ang) * dist + 'px');
      p.style.setProperty('--by', Math.sin(ang) * dist - 30 + 'px');
      p.style.animationDelay = (Math.random() * 80) + 'ms';
      b.appendChild(p);
    }
    document.body.appendChild(b);
    setTimeout(function () { b.remove(); }, 900);
  };

  // Buy-box booster: montar breadcrumb arriba del main y strip de urgencia junto al botón de compra
  var bc = document.getElementById('gc-bc');
  var mainSection = document.querySelector('.shopify-section:has(form[action*="/cart/add"]), main .shopify-section');
  if (bc && mainSection) {
    bc.hidden = false;
    mainSection.parentNode.insertBefore(bc, mainSection);
  }
  var bx = document.getElementById('gc-bx');
  var buyFormEarly = document.querySelector('form[action*="/cart/add"], product-form form');
  if (bx && buyFormEarly) {
    bx.hidden = false;
    buyFormEarly.insertAdjacentElement('afterend', bx);
    var sz = document.getElementById('gc-size');
    if (sz) { sz.hidden = false; bx.insertAdjacentElement('afterend', sz); }
    setInterval(function () {
      var h = document.getElementById('gc-pb-h');
      var el = document.getElementById('gc-bx-count');
      if (h && el) el.textContent = h.textContent + ':' + document.getElementById('gc-pb-m').textContent + ':' + document.getElementById('gc-pb-s').textContent;
    }, 1000);
  }

  // Sticky add-to-cart: aparece cuando el form de compra sale del viewport
  var sticky = document.getElementById('gc-sticky');
  var bxRef = document.getElementById('gc-bx');
  var szRef = document.getElementById('gc-size');
  if (sticky && document.querySelector('form[action*="/cart/add"]')) {
    sticky.hidden = false;
    // Horizon re-renderiza el product-form al hidratar: NO observar el nodo (queda huérfano).
    // Re-query del form vivo en cada frame de scroll + re-montaje defensivo del strip.
    var stickyRaf = null;
    // precio del sticky sigue a la variante VIVA del form (no queda congelado en la inicial)
    var lastVid = null;
    function fmtMoney(cents) { return '$' + Math.round(cents / 100).toLocaleString('es-AR'); }
    function syncStickyPrice() {
      var f = document.querySelector('form[action*="/cart/add"]');
      var idInput = f && f.querySelector('input[name="id"], select[name="id"]');
      var vid = idInput ? String(idInput.value) : sticky.dataset.vid;
      if (vid === lastVid || !window.GC_PDP_VARS || !window.GC_PDP_VARS[vid]) return;
      lastVid = vid;
      var d = window.GC_PDP_VARS[vid];
      var pEl = document.getElementById('gc-sticky-price');
      var cEl = document.getElementById('gc-sticky-compare');
      if (pEl) pEl.textContent = fmtMoney(d.p);
      if (cEl) { if (d.c > d.p) { cEl.textContent = fmtMoney(d.c); cEl.hidden = false; } else { cEl.hidden = true; } }
    }
    function stickyCheck() {
      var f = document.querySelector('form[action*="/cart/add"]');
      if (f) {
        var r = f.getBoundingClientRect();
        sticky.classList.toggle('is-on', r.bottom < 0);
        if (bxRef && (!bxRef.isConnected || bxRef.previousElementSibling !== f)) {
          f.insertAdjacentElement('afterend', bxRef);
          if (szRef) { szRef.hidden = false; bxRef.insertAdjacentElement('afterend', szRef); }
        }
      }
      syncStickyPrice();
      stickyRaf = null;
    }
    document.addEventListener('change', function () { setTimeout(syncStickyPrice, 60); });
    window.addEventListener('scroll', function () { if (!stickyRaf) stickyRaf = requestAnimationFrame(stickyCheck); }, { passive: true });
    setTimeout(stickyCheck, 1500);

    function stickyTick() {
      var el = document.getElementById('gc-sticky-count');
      if (!el) return;
      var h = document.getElementById('gc-pb-h'), m = document.getElementById('gc-pb-m'), s = document.getElementById('gc-pb-s');
      if (h) el.textContent = h.textContent + ':' + m.textContent + ':' + s.textContent;
    }
    setInterval(stickyTick, 1000);

    document.getElementById('gc-sticky-add').addEventListener('click', function (ev) {
      var btn = this;
      if (window.gcBurst) window.gcBurst(ev.clientX, ev.clientY);
      var liveForm = document.querySelector('form[action*="/cart/add"]');
      var idInput = liveForm && liveForm.querySelector('input[name="id"], select[name="id"]');
      // Liquid NO corre en este bloque JS (bundle estático): el fallback viene del data-vid del markup
      var vid = idInput ? idInput.value : sticky.dataset.vid;
      var qEl = (liveForm && liveForm.querySelector('input[name="quantity"]')) || document.querySelector('input[name="quantity"]');
      var qty = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
      btn.disabled = true; btn.textContent = 'Agregando…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(vid, 10), quantity: qty }) })
        .then(function (r) { if (!r.ok) throw 0; window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; btn.textContent = 'Agregar al carrito'; });
    });
  }

  // Reveals
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e, i) {
      if (e.isIntersecting) { setTimeout(function () { e.target.classList.add('is-in'); }, i * 80); io.unobserve(e.target); }
    });
  }, { threshold: 0.15 });
  root.querySelectorAll('.gc-pb-reveal').forEach(function (el) { io.observe(el); });

  // Tilt 3D suave en la galería de la PDP (solo desktop con mouse)
  if (!window.matchMedia('(hover: hover)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  // Tilt por delegación: sobrevive al re-render de la galería de Horizon
  var MEDIA_SEL = 'media-gallery, .product__media, product-media, [class*="product-media"], [class*="media-gallery"], .product-information__media';
  var tiltRaf = null;
  document.addEventListener('mousemove', function (ev) {
    var media = ev.target.closest && ev.target.closest(MEDIA_SEL);
    if (!media || tiltRaf) return;
    tiltRaf = requestAnimationFrame(function () {
      var img = media.querySelector('img');
      if (img) {
        if (!img.dataset.gcTilt) {
          img.dataset.gcTilt = '1';
          media.style.perspective = '1200px';
          img.style.transition = 'transform .18s ease-out';
          img.style.willChange = 'transform';
        }
        var r = media.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        img.style.transform = 'rotateY(' + (x * 6) + 'deg) rotateX(' + (-y * 5) + 'deg) scale(1.015)';
      }
      tiltRaf = null;
    });
  }, { passive: true });
  document.addEventListener('mouseout', function (ev) {
    var media = ev.target.closest && ev.target.closest(MEDIA_SEL);
    if (media && (!ev.relatedTarget || !ev.relatedTarget.closest(MEDIA_SEL))) {
      var img = media.querySelector('img');
      if (img) img.style.transform = '';
    }
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-personaliza-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  var stage = document.getElementById('gc-ph-stage');
  if (!stage) return;
  var tintBody = document.getElementById('gc-ph-tint-body');
  var tintHandle = document.getElementById('gc-ph-tint-handle');
  var BODY = ['#15c0ff','#e93a19','#FFFFFF','#05d360','#dda02c','#873ca1','#fb5bbc','#f68012','#eaca28','#5748c4','#2a2b37','#bee32b','#24cafc'];
  var HANDLE = ['#FAF7F2','#2a2b37','#15c0ff','#e93a19','#05d360','#dda02c','#fb5bbc','#eaca28','#C8D0DA'];

  function build(boxId, colors, onPick, initial) {
    var box = document.getElementById(boxId);
    colors.forEach(function (hex) {
      var b = document.createElement('button');
      b.type = 'button'; b.style.background = hex;
      b.setAttribute('aria-label', 'Color ' + hex);
      b.setAttribute('aria-pressed', hex === initial ? 'true' : 'false');
      b.addEventListener('click', function () {
        box.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true'); onPick(hex);
      });
      box.appendChild(b);
    });
  }
  build('gc-ph-body', BODY, function (h) { tintBody.style.background = h; }, '#15c0ff');
  build('gc-ph-handle', HANDLE, function (h) { tintHandle.style.background = h; }, '#FAF7F2');

  // TILT 3D
  var craft = document.getElementById('gc-ph-craft');
  var coarse = window.matchMedia('(pointer:coarse)').matches;
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  if (craft && !coarse && !reduce) {
    var tRx = 0, tRy = 0, cRx = 0, cRy = 0, hovering = false, t0 = null;
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      tRy = ((e.clientX - r.left) / r.width - 0.5) * 15;
      tRx = -((e.clientY - r.top) / r.height - 0.5) * 8; hovering = true;
    });
    stage.addEventListener('pointerleave', function () { hovering = false; });
    (function loop(ts) {
      if (t0 === null) t0 = ts;
      var el = (ts - t0) / 1000;
      if (!hovering) { tRy = Math.sin(el * 0.7) * 5.5; tRx = Math.cos(el * 0.5) * 2; }
      cRx += (tRx - cRx) * 0.09; cRy += (tRy - cRy) * 0.09;
      craft.style.setProperty('--rx', cRx.toFixed(2) + 'deg');
      craft.style.setProperty('--ry', cRy.toFixed(2) + 'deg');
      requestAnimationFrame(loop);
    })(0);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-resume"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('gc-rs');
  if (!root) return;
  var raw = localStorage.getItem('gc-last-product');
  if (!raw || sessionStorage.getItem('gc-rs-dismissed')) return;
  var p;
  try { p = JSON.parse(raw); } catch (e) { return; }
  if (!p || !p.handle || !p.title) return;
  document.getElementById('gc-rs-img').src = p.image || '';
  document.getElementById('gc-rs-title').textContent = p.title;
  document.getElementById('gc-rs-price').textContent = p.price || '';
  var url = '/products/' + p.handle;
  document.getElementById('gc-rs-link').href = url;
  root.hidden = false;
  document.getElementById('gc-rs-close').addEventListener('click', function (e) {
    e.stopPropagation();
    sessionStorage.setItem('gc-rs-dismissed', '1');
    root.hidden = true;
  });
  if (window.matchMedia('(max-width: 600px)').matches) {
    root.querySelector('.gc-rs__inner').addEventListener('click', function () { window.location.href = url; });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-scrolly"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('gc-sy');
  if (!root || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var raf = null;
  function update() {
    var r = root.getBoundingClientRect();
    var total = r.height - window.innerHeight;
    var progress = Math.min(1, Math.max(0, -r.top / total));
    var scene = Math.min(2, Math.floor(progress * 3));
    if (root.dataset.scene !== String(scene)) {
      root.dataset.scene = scene;
      root.className = root.className.replace(/\bs-\d\b/g, '').trim() + ' s-' + scene;
    }
    raf = null;
  }
  window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-stats"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function fmt(n) { return n >= 1000000 ? (n / 1000000).toFixed(n % 1000000 ? 1 : 0).replace('.', ',') + 'M' : n.toLocaleString('es-AR'); }
  function animate(el) {
    var target = parseInt(el.dataset.count, 10);
    var suffix = el.dataset.suffix || '';
    if (reduced) { el.textContent = fmt(target) + suffix; return; }
    var start = null, dur = 1600;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(target * eased)) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { animate(e.target); io.unobserve(e.target); }
    });
  }, { threshold: 0.6 });
  var grid = document.getElementById('gc-stats-grid');
  if (grid && !reduced) {
    new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { grid.classList.add('is-scanned'); }
    }, { threshold: 0.5 }).observe(grid);
  }
  document.querySelectorAll('#gc-stats .gc-stats__num[data-count]').forEach(function (el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.getElementById('gc-scta');
  if (!bar) return;
  if (sessionStorage.getItem('gc-scta-closed') === '1') { bar.remove(); return; }
  bar.hidden = false;
  var shown = false;
  var footer = document.querySelector('footer') || document.querySelector('.footer');
  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var nearFooter = false;
    if (footer) {
      var fr = footer.getBoundingClientRect();
      nearFooter = fr.top < window.innerHeight + 40;
    }
    var should = y > 700 && !nearFooter;
    if (should !== shown) {
      shown = should;
      bar.classList.toggle('is-on', shown);
      bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
      document.body.classList.toggle('gc-scta-on', shown);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();
  document.getElementById('gc-scta-close').addEventListener('click', function () {
    bar.classList.remove('is-on');
    document.body.classList.remove('gc-scta-on');
    try { sessionStorage.setItem('gc-scta-closed', '1'); } catch (e) {}
    setTimeout(function () { bar.remove(); }, 400);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-whatsapp-fab"] && !Shopify.designMode) return;
  try {
    
(function () {
  var fill = document.getElementById('gc-progress-fill');
  if (!fill) return;
  function update() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    fill.style.width = (max > 0 ? Math.min(100, window.scrollY / max * 100) : 0) + '%';
  }
  window.addEventListener('scroll', update, { passive: true });
  document.addEventListener('scroll', update, { passive: true, capture: true });
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
